import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from '../icon/IconWithTooltip';

export const ExternalLinkIcon = ({ handleClick, ariaLabel, tooltip }) => (
  <IconWithTooltip
    icon="external-link-square-alt"
    handleClick={handleClick}
    ariaLabel={ariaLabel}
    tooltip={tooltip}
  />
);


ExternalLinkIcon.propTypes = {
// eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
  ariaLabel: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
};
